import { fromJS } from 'immutable/dist/immutable';
import {
  normalizeInitialFormValues, fieldToNumber, fieldTrimmed,
} from '../../../../../form/formUtilities';

export const createInitialForm = marigram => fromJS({
  id: normalizeInitialFormValues(marigram, ['id']),
  publish: normalizeInitialFormValues(marigram, ['publish'], true),
  year: normalizeInitialFormValues(marigram, ['year']),
  month: normalizeInitialFormValues(marigram, ['month']),
  day: normalizeInitialFormValues(marigram, ['day']),
  locationName: normalizeInitialFormValues(marigram, ['locationName']),
  tsunamiEventId: normalizeInitialFormValues(marigram, ['tsunamiEventId']),
  // referenceIds: marigram && marigram.get('referenceIds') ? marigram.get('referenceIds').map(v => `${v}`) : [],
});

export const marigramEditModel = fromJS({
  name: 'marigramEditForm',
  initialValues: createInitialForm(),
});

export const formToJson = form => ({
  id: fieldToNumber(form.get('id')),
  publish: Boolean(form.get('publish')),
  year: fieldToNumber(form.get('year')),
  month: fieldToNumber(form.get('month')),
  day: fieldToNumber(form.get('day')),
  locationName: fieldTrimmed(form.get('locationName')),
  tsunamiEventId: fieldToNumber(form.get('tsunamiEventId')),
  // referenceIds: fromJS(form.get('referenceIds')).map(fieldToNumber).filter(value => value != null),
});
